import { createSelector } from 'reselect';

import { FEATURES } from '../constants';

import { appState } from './utils';

export const isParticipatingInFreshChat = createSelector(appState, ({ experimentation }) => {
  const freshChatResponse = experimentation[FEATURES.FRESH_CHAT];
  const isParticipating = freshChatResponse?.config?.variate_id === 'enabled';
  return isParticipating;
});
